"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValue = exports.FieldLabel = exports.Field = exports.PageItem = exports.SectionTitle = exports.SectionHeader = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
exports.SectionHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0 20px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    margin: 40px 0 16px;
  }
`;
exports.SectionTitle = (0, styled_components_1.default)(material_1.Typography) ``;
exports.PageItem = styled_components_1.default.div(({ theme: { palette, shape } }) => (0, styled_components_1.css) `
    background-color: ${palette.common.white};
    padding: 16px;
    border-radius: ${shape.borderRadius}px;

    @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
      padding: 24px 40px 28px 28px;
    }
  `);
exports.Field = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
exports.FieldLabel = (0, styled_components_1.default)(material_1.Typography) `
  font-weight: 700;
`;
exports.FieldValue = (0, styled_components_1.default)(material_1.Typography) ``;
